module.exports = __webpack_public_path__ + "img/candado.5ae156db.svg";